import { render, staticRenderFns } from "./MainStorage.vue?vue&type=template&id=3feb0a34&scoped=true&"
import script from "./MainStorage.vue?vue&type=script&lang=js&"
export * from "./MainStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3feb0a34",
  null
  
)

export default component.exports